import actions from './constants';

export const fetchPmnFunctions = (category) => ({
  type: actions.FETCH_PMN_FUNCTIONS,
  category,
});

export const refreshPmnFunctions = (category) => ({
  type: actions.REFRESH_PMN_FUNCTIONS,
  category,
});

export const showPmnFunctions = (category, results) => ({
  type: actions.SHOW_PMN_FUNCTIONS,
  category,
  results,
});

export const showPmnFunctionsError = (category, error) => ({
  type: actions.SHOW_PMN_FUNCTIONS_ERROR,
  category,
  error,
});

export const fetchPmnFunction = (category, code) => ({
  type: actions.FETCH_PMN_FUNCTION,
  category,
  code,
});

export const showPmnFunction = (category, code, result) => ({
  type: actions.SHOW_PMN_FUNCTION,
  category,
  code,
  result,
});

export const showPmnFunctionError = (category, code, error) => ({
  type: actions.SHOW_PMN_FUNCTION_ERROR,
  category,
  code,
  error,
});
